import React, { useState } from "react";
import moment from "moment";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  // Checkbox,
  Button,
  Modal,
  Link,
  TextField,
  Alert,
  CircularProgress,
} from "@mui/material";

import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const CustomTextarea = styled(TextField)(() => ({
  width: "60%",
  // marginTop: "20px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    // padding: "10px 20px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "10px 20px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const AsignVotes = ({ setOpen, open, selectedUser, refreshUser }) => {
  // "";
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);

  const formik = useFormik({
    initialValues: {
      freeVotes: "",
    },
    validationSchema: Yup.object().shape({
      freeVotes: Yup.number("Please enter integer value")
        .required("Please Enter the Free Votes")
        .typeError("Free votes must be an integer"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      values.userId = selectedUser.current.id;
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/assignFreeVotes`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.success) {
          console.log(
            "inf if ",
            response.data.success,
            "dlsajas",
            response.data.message,
          );
          toast.success(response.data.message);
          setOpen(false);
          refreshUser();
          // toast.success("test");
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error("error !!");
      } finally {
        setLoading(false);
        resetForm();
        // setOpen(false);
      }
    },
  });


  return (
    <>
      <ToastContainer />
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="assing-vote-modal">
          <Box className="title">
            <Typography component="h2">ASSIGN VOTES</Typography>
          </Box>
          <Box className="content">
            <Box className="content-wrapper">
              <form onSubmit={formik.handleSubmit}>
                {/* <Typography component="h2">
                  Allot votes to {selectedUser.current?.firstName || ""}{" "}
                  {selectedUser.current?.lastName || ""} as Award .
                </Typography> */}
                <Typography component="h2">
                  The user {selectedUser.current?.firstName || ""}{" "}
                  {selectedUser.current?.lastName || ""} currently has <br></br>
                  <span style={{ color: "#ef364e", fontWeight: "bold" }}>
                    {selectedUser?.current?.UsersVote[0]?.current_vote || "0"}{" "}
                    Free Votes.
                  </span>
                  <br></br>
                  Allot Free votes as Award .
                </Typography>
                {/* <Typography component="h2">
                  Allot Free votes as Award .
                </Typography> */}
                {/* <Box className="form-control"> */}

                {formik.touched.freeVotes && formik.errors.freeVotes ? (
                  <Alert style={{ margin: "5px 0" }} severity="error">
                    {formik.errors.freeVotes}
                  </Alert>
                ) : (
                  ""
                )}
                <CustomTextarea
                  id="outlined-multiline-static"
                  placeholder="Enter Free Votes"
                  variant="outlined"
                  value={formik.values.freeVotes}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="freeVotes"
                />
                {/* </Box> */}
                <Box className="form-control-buttons">
                  <Button type="submit" disabled={loading}>
                    {loading ? (
                      <CircularProgress size={25} sx={{ color: "#ef364e" }} />
                    ) : (
                      "Save"
                    )}
                  </Button>{" "}
                </Box>
              </form>
            </Box>
          </Box>
          <Box className="actions">
            <Box className="action-wrapper">
              <Button
                onClick={() => {
                  setOpen(false);
                  formik.resetForm();
                }}
              >
                Exit
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AsignVotes;
